import { Pipe, PipeTransform } from "@angular/core"
import { IDropdownOtherFieldValue } from "@mmx/shared"

@Pipe({
  name: 'otherDropdownValue',
  standalone: false,
})
export class OtherDropdownValuePipe implements PipeTransform {
  public transform(value: string | string[] | IDropdownOtherFieldValue, prefix = 'Other'): string {
    if (typeof value === 'string') {
      return value
    }

    if (Array.isArray(value)) {
      return value.join(', ')
    }

    return `${prefix}: ${value.value}`
  }
}
